import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import CustomerCombine from 'models/location/customer_combine';
import ExternalCustomerLookup from 'models/location/external_customer_lookup';
import { ExternalCustomerLookupStatusValue } from 'models/external_customer_lookup_status';
import { MenuContainer, MenuItem } from 'components/lib/menu_deprecated';
import MenuIcon from 'components/lib/icons/menu_icon';
import NavigateTo from 'actions/current_location/navigate_to';
import OpenModal from 'actions/modal/open_modal';
import RefreshExternalCustomerData from 'actions/external_customer_lookup/refresh_external_customer_data';
import UnlinkProfile from 'models/modal/unlink_profile';

export class CustomerSummaryMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };

    _.bindAll(this, ['handleClose', 'handleOpen', 'handleSelectCombineCustomers']);
  }

  render() {
    return (
      <MenuContainer
        button={<MenuIcon className={this.getButtonClassName()} />}
        className="customerSummaryMenu"
        onClose={this.handleClose}
        onOpen={this.handleOpen}
      >
        {this.renderUnlinkProfile()}
        {this.renderCombineCustomers()}
        {this.renderRefreshExternalData()}
        {this.renderReplaceCustomerLink()}
      </MenuContainer>
    );
  }

  renderRefreshExternalData() {
    if (!this.props.shouldShowLookupActions) {
      return null;
    }
    return (
      <MenuItem
        className="customerSummaryMenu-item customerSummaryMenu-refreshCustomer"
        onSelect={this.props.onSelectRefreshCustomerData}
      >
        Refresh customer data
      </MenuItem>
    );
  }

  renderCombineCustomers() {
    return (
      <MenuItem
        className="customerSummaryMenu-item  customerSummaryMenu-combineCustomers"
        onSelect={this.handleSelectCombineCustomers}
      >
        Combine Customers...
      </MenuItem>
    );
  }

  renderReplaceCustomerLink() {
    if (!this.props.shouldShowLookupActions || this.props.shouldNotShowRelink) {
      return null;
    }
    return (
      <MenuItem
        className="customerSummaryMenu-item customerSummaryMenu-replaceCustomerLink"
        onSelect={this.props.onSelectReplaceCustomerLink}
      >
        Replace customer link
      </MenuItem>
    );
  }

  renderUnlinkProfile() {
    if (!this.props.shouldShowUnlinkProfile) {
      return null;
    }
    return (
      <MenuItem
        className="customerSummaryMenu-item customerSummaryMenu-unlinkCustomer"
        onSelect={this.props.onSelectUnlinkCustomer}
      >
        Unlink Customer
      </MenuItem>
    );
  }

  getButtonClassName() {
    return classnames('customerSummaryMenu-button-icon', {
      'customerSummaryMenu-button-icon-active': this.state.isOpen,
    });
  }

  handleClose() {
    this.setState({ isOpen: false });
  }

  handleOpen() {
    this.setState({ isOpen: true });
  }

  handleSelectCombineCustomers() {
    if (this.props.onSelectCombineCustomers) {
      this.props.onSelectCombineCustomers();
    }
  }
}

CustomerSummaryMenu.propTypes = {
  onSelectCombineCustomers: PropTypes.func,
  onSelectRefreshCustomerData: PropTypes.func,
  onSelectReplaceCustomerLink: PropTypes.func,
  onSelectUnlinkCustomer: PropTypes.func,
  shouldShowLookupActions: PropTypes.bool,
  shouldNotShowRelink: PropTypes.bool,
  shouldShowUnlinkProfile: PropTypes.bool,
};

const CustomerSummaryMenuContainer = connect(mapStateToProps, mapExecuteToProps)(CustomerSummaryMenu);

function mapStateToProps({ getProvider, isFeatureEnabled }, props) {
  const profile = getProvider('profile').get();
  const lookupStatus = getProvider('externalCustomerLookupStatus').get();

  const customerIsLinked = !!(profile && (profile.externalCustomerId || !_.isEmpty(profile.externalCustomerIds)));
  const basicDisabled = !!(lookupStatus && lookupStatus.basicDisabled);

  const shouldShowLookupActions = !!(
    customerIsLinked &&
    lookupStatus &&
    lookupStatus.status === ExternalCustomerLookupStatusValue.OK
  );

  const shouldNotShowRelink = basicDisabled;

  const shouldShowUnlinkProfile = !!(shouldShowLookupActions && !basicDisabled);

  return {
    shouldShowLookupActions,
    shouldNotShowRelink,
    shouldShowUnlinkProfile,
  };
}

CustomerSummaryMenuContainer.propTypes = {
  customerId: PropTypes.string.isRequired,
};

export default CustomerSummaryMenuContainer;

function mapExecuteToProps(executeAction, { customerId }) {
  return {
    onSelectCombineCustomers: () => executeAction(NavigateTo, CustomerCombine.create({ customerId })),
    onSelectRefreshCustomerData: () => executeAction(RefreshExternalCustomerData),
    onSelectReplaceCustomerLink: () => executeAction(NavigateTo, ExternalCustomerLookup.create({ customerId })),
    onSelectUnlinkCustomer: () => executeAction(OpenModal, new UnlinkProfile({ customerId })),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/customer_summary_menu.jsx